export default "__VITE_ASSET__5b703ac2__"